import * as yup from "yup";
import { StatisticsType } from "../../../common/enums";

const validStatisticsTypes = Object.values(StatisticsType).filter(
  (value) => typeof value === "number"
) as number[];

// Sentinel id used by the multi-select "All halls" option. Mirrors the planner pattern.
export const ALL_HALLS_OPTION_ID = 0;

// Sentinel id used by the multi-select "All employees" option. Mirrors ALL_HALLS_OPTION_ID.
// When picked, the URL/API uses ALL_USERS_URL_TOKEN ("all") so the backend skips the
// user-id filter entirely — important for surfacing admin-created activity (e.g. gym
// check-ins by a global admin not in the selectable employee list).
export const ALL_USERS_OPTION_ID = 0;

export const statisticsFormSchema = yup
  .object({
    type: yup
      .number()
      .oneOf(validStatisticsTypes, "Невалиден тип на репорт.")
      .required("Типът на репорта е задължителен.")
      .defined(),
    dateFrom: yup
      .date()
      .required("Началната дата е задължителна.")
      .typeError("Невалидна начална дата.")
      .defined(),
    userIds: yup.array().nullable().defined(),
    hallIds: yup.array().of(yup.number().required()).nullable().defined(),
    dateTo: yup
      .date()
      .required("Крайната дата е задължителна.")
      .typeError("Невалидна крайна дата.")
      .min(
        yup.ref("dateFrom"),
        "Крайната дата трябва да е след началната дата."
      )
      .defined(),
  })
  .required();

export type IStatisticsFormModel = yup.InferType<typeof statisticsFormSchema>;

export const statisticsFormDefaultValues: IStatisticsFormModel = {
  type: StatisticsType.Money,
  dateFrom: new Date(new Date().setDate(new Date().getDate() - 7)),
  dateTo: new Date(),
  userIds: [ALL_USERS_OPTION_ID],
  hallIds: [ALL_HALLS_OPTION_ID],
};

export const isAllHallsSelected = (hallIds: number[] | null | undefined): boolean =>
  !hallIds || hallIds.length === 0 || hallIds.includes(ALL_HALLS_OPTION_ID);

export const isAllUsersSelected = (userIds: number[] | null | undefined): boolean =>
  !userIds || userIds.length === 0 || userIds.includes(ALL_USERS_OPTION_ID);
